import styled from 'styled-components';
import { ButtonState } from '.';

interface BaseProps {
	backgroundColor: string;
	hoverBackgroundColor: string;
	activeBackgroundColor: string;
	borderColor: string;
	labelColor: string;
	width: string;
	height: number;
	fontSize: number;
	state: ButtonState;
}

export const Base = styled.button<BaseProps>`
	// Size
	min-width: ${(p) => p.width};
	height: ${(p) => p.height}px;
	font-size: ${(p) => p.fontSize}px;
	font-weight: 500;
	padding-left: 12px;
	padding-right: 12px;
	box-sizing: border-box;
	overflow: hidden;
	text-overflow: ellipsis;

	// Center text vertically
	// I hate stuff like this: subtracting 1px makes the text *look* vertically centered with Inter.
	// Normally I would just mirror the height exactly.
	line-height: ${(p) => p.height - 1}px;
	padding-top: 0;
	padding-bottom: 0;

	// Style
	background: ${(p) => p.backgroundColor};
	color: ${(p) => p.labelColor};
	border: 1px solid ${(p) => p.borderColor};
	border-radius: 20px;
	text-align: center;
	user-select: none;
	cursor: ${(p) => (p.state === ButtonState.DISABLED ? 'not-allowed' : 'default')};

	&:hover {
		background: ${(p) => p.hoverBackgroundColor};
	}

	&:active {
		background: ${(p) => p.activeBackgroundColor};
	}
`;
